export enum ViewMode {
    APP = "APP",
    IFRAME = "IFRAME",
    CLIENTES = "CLIENTES",
} 